import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import MfaGate from './MfaGate';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isAdmin, logout } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <div style={styles.wrapper}>
      <nav style={styles.nav}>
        <div style={styles.navInner}>
          <Link to="/" style={styles.brand}>
            MCP Access Portal
          </Link>

          <div style={styles.links}>
            {user && (
              <>
                <Link
                  to="/request"
                  style={{
                    ...styles.link,
                    ...(isActive('/request') ? styles.activeLink : {}),
                  }}
                >
                  New Request
                </Link>
                <Link
                  to="/my-requests"
                  style={{
                    ...styles.link,
                    ...(isActive('/my-requests') ? styles.activeLink : {}),
                  }}
                >
                  My Requests
                </Link>
                <Link
                  to="/credentials"
                  style={{
                    ...styles.link,
                    ...(isActive('/credentials') ? styles.activeLink : {}),
                  }}
                >
                  Credentials
                </Link>
                {isAdmin && (
                  <>
                    <Link
                      to="/admin"
                      style={{
                        ...styles.link,
                        ...(isActive('/admin') ? styles.activeLink : {}),
                      }}
                    >
                      Admin
                    </Link>
                    <Link
                      to="/admin/users"
                      style={{
                        ...styles.link,
                        ...(isActive('/admin/users') ? styles.activeLink : {}),
                      }}
                    >
                      Users
                    </Link>

                  </>
                )}
              </>
            )}
          </div>

          <div style={styles.right}>
            {user ? (
              <div style={styles.userArea}>
                <span style={styles.email}>{user.email}</span>
                <button onClick={logout} style={styles.logoutBtn}>
                  Sign Out
                </button>
              </div>
            ) : (
              <span style={styles.email}>Not signed in</span>
            )}
          </div>
        </div>
      </nav>

      <main style={styles.main}><MfaGate>{children}</MfaGate></main>

      <footer style={styles.footer}>
        <p>MCP Access Request Portal</p>
      </footer>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  nav: {
    background: '#1a1a2e',
    color: '#fff',
    padding: '0 1.5rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  navInner: {
    maxWidth: 1200,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    height: 56,
    gap: '2rem',
  },
  brand: {
    color: '#fff',
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: '1.1rem',
    letterSpacing: '-0.02em',
  },
  links: {
    display: 'flex',
    gap: '1rem',
    flex: 1,
  },
  link: {
    color: '#ced4da',
    textDecoration: 'none',
    fontSize: '0.9rem',
    padding: '0.25rem 0.5rem',
    borderRadius: 4,
    transition: 'color 0.15s',
  },
  activeLink: {
    color: '#fff',
    background: 'rgba(255,255,255,0.1)',
  },
  right: {
    marginLeft: 'auto',
  },
  userArea: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  email: {
    fontSize: '0.85rem',
    color: '#adb5bd',
  },
  logoutBtn: {
    background: 'transparent',
    border: '1px solid #555',
    color: '#ccc',
    padding: '0.3rem 0.75rem',
    borderRadius: 4,
    cursor: 'pointer',
    fontSize: '0.8rem',
  },
  main: {
    flex: 1,
    maxWidth: 1200,
    width: '100%',
    margin: '0 auto',
    padding: '2rem 1.5rem',
  },
  footer: {
    textAlign: 'center',
    padding: '1.5rem',
    color: '#999',
    fontSize: '0.8rem',
    borderTop: '1px solid #e0e0e0',
  },
};

export default Layout;
